export const config = Object.freeze({
	ENV: process.env.NODE_ENV,
	API_ADDR: process.env.REACT_APP_API_ADDR
})